module.exports = __webpack_public_path__ + "static/media/no_seating.ff8e48f1.svg";